import { BookOpen, X } from "lucide-react";
import { Button } from "./button";

interface QuotaEducationCardProps {
    isVisible: boolean;
    onDismiss: () => void;
    storiesLimit: number;
}

export function QuotaEducationCard({ isVisible, onDismiss, storiesLimit }: QuotaEducationCardProps) {
    if (!isVisible) return null;

    return (
        <div className="relative bg-gradient-to-r from-primary/5 to-secondary/5 border border-primary/20 rounded-xl p-4 shadow-sm">
            <button
                onClick={onDismiss}
                className="absolute top-2 right-2 p-1 rounded-full hover:bg-background/50 transition-colors"
                aria-label="Close"
            >
                <X className="w-3 h-3 text-muted-foreground" />
            </button>

            <div className="flex items-start gap-3 pr-8">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <BookOpen className="w-4 h-4 text-primary" />
                </div>

                <div className="flex-1 space-y-2">
                    <div>
                        <h3 className="font-semibold text-foreground">Welcome to StoryDoodle! 🎉</h3>
                        <p className="text-sm text-muted-foreground">
                            You can create up to {storiesLimit} stories each day, then get fresh adventures tomorrow!
                        </p>
                    </div>

                    <div className="flex justify-center">
                        <Button size="sm" variant="outline" onClick={onDismiss} className="text-xs">
                            Got it!
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
